import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=2faefd3e&scoped=true&"
import script from "./CompanyPage.vue?vue&type=script&lang=js&"
export * from "./CompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=2faefd3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faefd3e",
  null
  
)

export default component.exports